import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="flex w-9 h-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-table-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold">
                AllChinaBuy <span className="text-accent-400">Spreadsheet</span>
              </span>
            </div>
            <p className="text-sm text-background-200 leading-relaxed mb-4">{t('footer.tagline')}</p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaPrimary')}
              <span className="flex w-4 h-4 items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              <Link to="/spreadsheet" className="hover:text-accent-400 transition-colors">{t('footer.categories')}</Link>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {t(`cat.${cat.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
              <Link to="/spreadsheet" className="hover:text-accent-400 transition-colors">{t('footer.categories')}</Link>
            </h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {t(`cat.${cat.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-200 hover:text-accent-400 transition-colors">
                  {t('footer.home')}
                </Link>
              </li>
              <li>
                <Link to="/guides" className="text-sm text-background-200 hover:text-accent-400 transition-colors">
                  {t('nav.guides')}
                </Link>
              </li>
              <li>
                <Link to="/safety" className="text-sm text-background-200 hover:text-accent-400 transition-colors">
                  {t('nav.safety')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800">
          <p className="text-xs text-background-300 leading-relaxed mb-4">{t('footer.disclaimer')}</p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-background-300">
              © {new Date().getFullYear()} AllChinaBuy Spreadsheet. {t('footer.rights')}
            </p>
            <div className="flex items-center gap-4">
              <Link to="/safety" className="text-xs text-background-300 hover:text-accent-400 transition-colors">
                {t('footer.privacy')}
              </Link>
              <Link to="/safety" className="text-xs text-background-300 hover:text-accent-400 transition-colors">
                {t('footer.terms')}
              </Link>
              <Link to="/safety" className="text-xs text-background-300 hover:text-accent-400 transition-colors">
                {t('footer.disclaimerLink')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}